module.exports = __webpack_public_path__ + "img/Zambia.bbb8d20f.svg";